module.exports = __webpack_public_path__ + "static/media/vote.a8ecc7b4.png";